import { hasWebview2 } from './hasWebView2'

type VisualStudioNativeMessage = {
  Message: string
  Args: any
}

export const notifyXbox = (data: string | VisualStudioNativeMessage) => {
  const str = typeof data === 'string' ? data : JSON.stringify(data)
  if (hasWebview2()) {
    try {
      window.chrome?.webview?.postMessage(str)
    } catch (_) {}
  }
}
